import React from 'react'
import { Table, Tag, Button, Tooltip } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import moment from 'moment-timezone'

const STATUS_COLORS = {
  waiting: 'blue',
  active: 'green',
  completed: 'default',
  failed: 'red',
  delayed: 'orange',
}

const JobsTable = ({
  jobs,
  loading,
  pagination,
  status,
  timezone,
  use24h,
  onPageChange,
  onRetry,
  onRowClick,
}) => {
  const fmt = use24h ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD h:mm:ss A'
  const formatTs = (val) => val ? moment(val).tz(timezone).format(fmt) : '-'

  const columns = [
    {
      title: 'Job Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (val) => <Tag color={STATUS_COLORS[val]}>{val}</Tag>,
    },
    {
      title: 'Attempts',
      dataIndex: 'attemptsMade',
      key: 'attemptsMade',
      width: 80,
      align: 'center',
    },
    {
      title: 'Created',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 200,
      render: formatTs,
    },
    {
      title: 'Processed',
      dataIndex: 'processedOn',
      key: 'processedOn',
      width: 200,
      render: formatTs,
    },
    {
      title: 'Error',
      dataIndex: 'failedReason',
      key: 'failedReason',
      ellipsis: true,
      render: (val) => val ? (
        <Tooltip title={val}>
          <span style={{ color: '#ff4d4f' }}>{val}</span>
        </Tooltip>
      ) : '-',
    },
    ...(status === 'failed' ? [{
      title: '',
      key: 'actions',
      width: 80,
      render: (_, record) => (
        <Button
          size="small"
          icon={<ReloadOutlined />}
          onClick={(e) => {
            e.stopPropagation()
            onRetry(record.id)
          }}
        >
          Retry
        </Button>
      ),
    }] : []),
  ]

  return (
    <Table
      dataSource={jobs}
      columns={columns}
      rowKey="id"
      loading={loading}
      size="small"
      onRow={(record) => ({
        onClick: () => onRowClick(record),
        style: { cursor: 'pointer' },
      })}
      pagination={{
        current: pagination.page,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showTotal: (total) => `${total} jobs`,
        onChange: onPageChange,
      }}
    />
  )
}

export default JobsTable
